// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application";
import { registerControllers } from "stimulus-vite-helpers";

registerControllers(application, import.meta.glob("./**/*_controller.{js,ts,tsx}", { eager: true }));

// TODO: set up channels https://github.com/DavidColby/vite_starter_template/blob/main/app/javascript/controllers/index.js
